<template>
  <transition-group
    name="snackbar-stack"
    tag="div"
    class="snackbar-stack"
  >
    <div
      v-for="message in snackbarMessages"
      :key="message.id"
      class="snackbar-toast"
      :class="`snackbar-toast--${message.type}`"
      @mouseenter="pauseTimer(message.id)"
      @mouseleave="resumeTimer(message.id)"
    >
      <span class="snackbar-toast__icon">
        <svg
          v-if="message.type === 'success'"
          viewBox="0 0 24 24"
          fill="none"
        >
          <circle
            cx="12"
            cy="12"
            r="9"
            stroke="#fff"
            stroke-width="1.8"
          />
          <path
            d="M8.2 12.4l2.5 2.5 5.1-5.4"
            stroke="#fff"
            stroke-width="1.9"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <svg
          v-else-if="message.type === 'error'"
          viewBox="0 0 24 24"
          fill="none"
        >
          <circle
            cx="12"
            cy="12"
            r="9"
            stroke="#fff"
            stroke-width="1.8"
          />
          <path
            d="M12 7.6v5.2"
            stroke="#fff"
            stroke-width="2"
            stroke-linecap="round"
          />
          <circle
            cx="12"
            cy="16.2"
            r="1.2"
            fill="#fff"
          />
        </svg>
        <svg
          v-else-if="message.type === 'warning'"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 4 21.2 19.6H2.8L12 4z"
            stroke="#fff"
            stroke-width="1.8"
            stroke-linejoin="round"
          />
          <path
            d="M12 10v4"
            stroke="#fff"
            stroke-width="1.9"
            stroke-linecap="round"
          />
          <circle
            cx="12"
            cy="16.8"
            r="1.1"
            fill="#fff"
          />
        </svg>
        <svg
          v-else
          viewBox="0 0 24 24"
          fill="none"
        >
          <circle
            cx="12"
            cy="12"
            r="9"
            stroke="#fff"
            stroke-width="1.8"
          />
          <circle
            cx="12"
            cy="8.2"
            r="1.2"
            fill="#fff"
          />
          <path
            d="M12 11.4v5"
            stroke="#fff"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </span>

      <div class="snackbar-toast__body">
        <div
          v-if="titles[message.type]"
          class="snackbar-toast__title"
        >
          {{ titles[message.type] }}
        </div>
        <div class="snackbar-toast__text">
          {{ message.text }}
        </div>
      </div>

      <button
        class="snackbar-toast__close"
        type="button"
        title="Закрыть"
        @click="close(message.id)"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M7 7l10 10M17 7L7 17"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </div>
  </transition-group>
</template>

<script>
  import { mapState } from 'vuex'

  const RESUME_TIMEOUT = 2500

  export default {
    name: 'CustomSnackbar',
    data () {
      return {
        timers: {},
        // Для success заголовок не показываем - достаточно зелёной плашки с галкой
        titles: {
          success: '',
          error: 'Ошибка',
          warning: 'Внимание',
          info: 'Информация',
        },
      }
    },
    computed: {
      ...mapState({
        snackbarMessages: (state) => state.app.snackbarMessages,
      }),
    },
    watch: {
      snackbarMessages (messages) {
        messages.forEach((message) => {
          if (!(message.id in this.timers)) {
            this.startTimer(message.id, message.timeout)
          }
        })
        Object.keys(this.timers).forEach((id) => {
          if (!messages.some((message) => message.id === Number(id))) {
            clearTimeout(this.timers[id])
            this.$delete(this.timers, id)
          }
        })
      },
    },
    beforeDestroy () {
      Object.values(this.timers).forEach(clearTimeout)
    },
    methods: {
      startTimer (id, timeout) {
        this.$set(this.timers, id, setTimeout(() => this.close(id), timeout))
      },
      pauseTimer (id) {
        clearTimeout(this.timers[id])
      },
      resumeTimer (id) {
        if (id in this.timers) {
          this.$set(this.timers, id, setTimeout(() => this.close(id), RESUME_TIMEOUT))
        }
      },
      close (id) {
        this.$store.commit('app/removeSnackbarMessage', id)
      },
    },
  }
</script>

<style lang="less" scoped>
  @snackbar-success: #4caf50;
  @snackbar-error: #DE3730; // red;// @color-error;
  @snackbar-warning: #ffa000;
  @snackbar-info: #2196f3;

  .snackbar-stack {
    position: fixed;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10000;
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 560px;
    max-width: calc(100vw - 32px);
    pointer-events: none;
  }

  .snackbar-toast {
    pointer-events: auto;
    position: relative;
    display: flex;
    gap: 12px;
    align-items: center;
    border-radius: 5px;
    padding: 13px 14px;
    transition: transform 0.5s cubic-bezier(0.34, 1.45, 0.64, 1), opacity 0.3s;

    &--success {
      background: @snackbar-success;
      box-shadow: 0 3px 12px fade(@snackbar-success, 22%);

      // Заголовка у успеха нет - текст сообщения набран как заголовок
      .snackbar-toast__text {
        color: #fff;
        //font-weight: 700;
        font-size: 17px;
      }
    }

    &--error {
      background: @snackbar-error;
      box-shadow: 0 3px 12px fade(@snackbar-error, 22%);
    }

    &--warning {
      background: @snackbar-warning;
      box-shadow: 0 3px 12px fade(@snackbar-warning, 22%);
    }

    &--info {
      background: @snackbar-info;
      box-shadow: 0 3px 12px fade(@snackbar-info, 22%);
    }

    &__icon {
      flex: none;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 28px;
        height: 28px;
      }
    }

    &__body {
      min-width: 0;
    }

    &__title {
      color: #fff;
      font-weight: 700;
      font-size: 17px;
      line-height: 1.35;
    }

    &__text {
      color: fade(#fff, 88%);
      font-size: 16px;
      line-height: 1.45;
      word-wrap: break-word;
    }

    &__close {
      flex: none;
      margin-left: auto;
      width: 24px;
      height: 24px;
      border: none;
      border-radius: 10px;
      background: fade(#000, 14%);
      color: #fff;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      transition: background 0.15s;

      svg {
        width: 14px;
        height: 14px;
      }

      &:hover {
        background: fade(#000, 30%);
      }
    }
  }

  /* Анимации стека: выезд сверху с пружинкой, уход вверх, плавное смещение остальных */
  .snackbar-stack-enter {
    transform: translateY(-32px) scale(0.96);
    opacity: 0;
  }

  .snackbar-stack-leave-active {
    position: absolute;
    right: 0;
    left: 0;
    transition: transform 0.3s cubic-bezier(0.4, 0, 1, 1), opacity 0.3s;
  }

  .snackbar-stack-leave-to {
    transform: translateY(-24px) scale(0.96);
    opacity: 0;
  }

  .snackbar-stack-move {
    transition: transform 0.35s ease;
  }
</style>
